import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import React from "react";
import Grid from "@material-ui/core/Grid";
import { IconButton, SecondaryButton } from "@prestosports/commons-ui";
import Close32 from "@carbon/icons-react/lib/close/32";
import Box from "@material-ui/core/Box";
import commonStyles from "../styles/Common.styles";
import newPeriodDialogStyles from "../styles/NewPeriodDialog.styles";
import OffenseTeam from "../../football/components/OffenseTeam";

const NewPeriodDialog = ({
	isOpen,
	onClose,
	homeTeam,
	awayTeam,
	homeTeamHasPossession,
	onReceivingTeamChange
}) => {
	const commonClasses = commonStyles();
	const classes = newPeriodDialogStyles();

	const handleChange = (event) => {
		onReceivingTeamChange(event.target.value);
	};

	const title = "Which team is receiving the kick off?";

	const controls = [
		{ label: awayTeam.teamName, id: "receiving-away", value: homeTeam.id },
		{ label: homeTeam.teamName, id: "receiving-home", value: awayTeam.id }
	];

	return (
		<Dialog
			open={isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			onClose={onClose}
		>
			<DialogTitle id="alert-dialog-title">
				New Period Started
				<IconButton
					onClick={onClose}
					aria-label="close-dialog"
					className={commonClasses.closeButton}
				>
					<Close32 />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers className={classes.dialogContent}>
				<DialogContentText id="alert-dialog-description">
					<Box className={classes.receivingTeamBox}>
						<OffenseTeam
							title={title}
							onChange={handleChange}
							offenseTeamId={homeTeamHasPossession ? homeTeam.id : awayTeam.id}
							controls={controls}
						/>
					</Box>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Grid container direction="row" justifyContent="flex-end" spacing={2}>
					<Grid item>
						<SecondaryButton label="Close" onClick={onClose} size="medium" />
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};

export default NewPeriodDialog;
